




import { useCastLayouts } from '@/modules/castLayouts/compositions'
import { useCurrentCast } from '@/modules/casts/compositions'
import { useCurrentCasterStream } from '@/modules/usermedia/compositions'
import { computed, defineComponent } from '@vue/composition-api'
import KisweIcon from '../KisweIcon'

export default defineComponent({
  name: 'KisweCasterTally',
  components: {
    KisweIcon
  },
  setup () {
    const { currentCast } = useCurrentCast()
    const { isCasterView } = useCastLayouts()
    const { streamId, isStreaming } = useCurrentCasterStream()
    const programSceneId = computed(() => currentCast.value?.programSceneId)
    const isCasterAudioEnabled = computed(() => {
      if (!streamId.value || !programSceneId.value) return false
      return currentCast.value?.isCasterAudioEnabled(streamId.value, programSceneId.value) ?? false
    })
    const isCasterBoxVisible = computed(() => {
      if (!streamId.value || !programSceneId.value) return false
      return currentCast.value?.isCasterBoxVisible(streamId.value, programSceneId.value) ?? false
    })
    const showTally = computed(() => {
      return isCasterView.value && isStreaming.value && (isCasterAudioEnabled.value || isCasterBoxVisible.value)
    })

    return {
      showTally
    }
  }
})
